import React from "react";
import { useNavigate } from "react-router-dom";
import { MarketingLayout, Section } from "@/components/marketing/MarketingLayout";
import { IMG } from "@/lib/constants";
import { Button } from "@/components/ui/button";

const PAGES = {
  solutions: {
    eyebrow: "Solutions", title: "Built for everyone who builds.",
    sub: "Different needs. One platform.", hero: IMG.workersGroup,
    cards: [
      ["Homeowners", "Build your home with confidence", IMG.villa],
      ["Contractors", "Plan projects without the chaos", IMG.cranesSkyline],
      ["Builders", "Scale construction operations", IMG.highrise],
      ["Architects", "Design, collaborate, deliver", IMG.blueprint],
      ["Interior Designers", "Turn designs into delivered spaces", IMG.homeLawn],
      ["Suppliers", "Reach projects that need you", IMG.materials],
    ],
  },
  industries: {
    eyebrow: "Industries", title: "From the individual home to the largest project.",
    sub: "Sitepar is built for every scale of construction.", hero: IMG.highrise,
    cards: [
      ["Residential", "Homes, villas, apartments", IMG.villa],
      ["Commercial", "Offices, retail, hospitality", IMG.cranesSkyline],
      ["Infrastructure", "Roads, bridges, public works", IMG.siteSunset],
      ["Industrial", "Factories, warehouses", IMG.materials],
      ["Real Estate", "Developer portfolios", IMG.highrise],
      ["Interiors", "Fit-outs and finishing", IMG.homeLawn],
    ],
  },
  resources: {
    eyebrow: "Resources", title: "Knowledge for a better-built India.",
    sub: "Guides, tools and insights for every stage of your journey.", hero: IMG.blueprint,
    cards: [
      ["Construction Cost Guide by City", "Cost Guides", IMG.materials],
      ["Top 10 Materials for Indian Homes", "Materials", IMG.materials],
      ["Home Design Ideas for Modern Living", "Design", IMG.villa],
      ["Building Approvals Made Simple", "Construction", IMG.blueprint],
      ["Contractor Agreement Template", "Templates", IMG.blueprint],
      ["How to Track Your Project", "Guides", IMG.cranesSkyline],
    ],
  },
  company: {
    eyebrow: "About Sitepar", title: "Building the infrastructure for how India builds.",
    sub: "Sitepar is a technology company building the digital infrastructure for India's construction economy.", hero: IMG.siteSunset,
    cards: [
      ["1M+", "Projects (target)", IMG.villa],
      ["10K+", "Professionals", IMG.workersGroup],
      ["500+", "Partners", IMG.materials],
      ["28", "Cities", IMG.cranesSkyline],
    ],
  },
  studio: {
    eyebrow: "Sitepar Studio", title: "From idea to buildable reality.",
    sub: "AI-powered design tools for homes and buildings, built for Indian construction.", hero: IMG.villa,
    cards: [
      ["Floor Plans", "2D layouts", IMG.blueprint],
      ["3D Design", "Photoreal views", IMG.villaDusk],
      ["Elevation", "Facade design", IMG.homeWhite],
      ["Interior Design", "Room by room", IMG.homeLawn],
      ["Structural", "GFC drawings", IMG.highrise],
      ["Material Specs", "BOQ-linked", IMG.materials],
    ],
  },
  "home-product": {
    eyebrow: "Sitepar Home", title: "Your home. Your project. Your intelligence.",
    sub: "Plan, design, budget and build your home from one intelligent workspace.", hero: IMG.villaDusk,
    cards: [
      ["AI Advisor", "Expert guidance", IMG.blueprint],
      ["Design Studio", "Plans, 3D, interiors", IMG.villa],
      ["Cost & BOQ", "Accurate estimates", IMG.materials],
      ["Build Tracking", "Live progress", IMG.cranesSkyline],
    ],
  },
};

export default function GenericPage({ slug }) {
  const nav = useNavigate();
  const p = PAGES[slug];
  if (!p) return <MarketingLayout><Section><h1 className="text-3xl font-bold">Coming soon</h1></Section></MarketingLayout>;
  return (
    <MarketingLayout>
      <section className="bg-sp-navy text-white relative overflow-hidden">
        <img src={p.hero} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="relative sp-container py-24">
          <div className="sp-eyebrow mb-4">{p.eyebrow}</div>
          <h1 className="text-4xl lg:text-5xl font-bold tracking-tight max-w-3xl">{p.title}</h1>
          <p className="mt-5 text-lg text-white/65 max-w-xl">{p.sub}</p>
          <Button data-testid={`generic-cta-${slug}`} onClick={() => nav("/register")} className="mt-8 bg-sp-orange hover:bg-sp-orangedark rounded-full h-11 px-6">Get Started</Button>
        </div>
      </section>
      <Section>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {p.cards.map(([a, b, img]) => (
            <div key={a} className="rounded-xl overflow-hidden border border-slate-200 sp-hover-card bg-white">
              <img src={img} alt={a} className="h-40 w-full object-cover" />
              <div className="p-5"><div className="font-semibold text-sp-navy text-lg">{a}</div><div className="text-sm text-slate-500 mt-1">{b}</div></div>
            </div>
          ))}
        </div>
      </Section>
    </MarketingLayout>
  );
}
